/**
 * @generated SignedSource<<ffa0a062a93448b57e072ac95506c79c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type yourSayQuery$data = {
  readonly yourSayQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly authors?: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"yourSayAuthorAuthor">;
          } | null | undefined> | null | undefined;
          readonly headline?: string | null | undefined;
          readonly socialHeadline?: string | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly yourSaySection: {
    readonly " $fragmentSpreads": FragmentRefs<"headlineSection">;
  };
  readonly " $fragmentType": "yourSayQuery";
};
export type yourSayQuery$key = {
  readonly " $data"?: yourSayQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"yourSayQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "yourSayQuery",
  "selections": [
    {
      "alias": "yourSaySection",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "515466"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "headlineSection"
        }
      ],
      "storageKey": "section(filter:{\"entityId\":\"515466\"})"
    },
    {
      "alias": "yourSayQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "section_top_515466"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "entityLink"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "headline",
                          "storageKey": null
                        },
                        {
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "withSize1200x800",
                              "value": true
                            },
                            {
                              "kind": "Literal",
                              "name": "withSize540x360",
                              "value": true
                            }
                          ],
                          "kind": "FragmentSpread",
                          "name": "contentCoverImageContent"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "socialHeadline",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Author",
                          "kind": "LinkedField",
                          "name": "authors",
                          "plural": true,
                          "selections": [
                            {
                              "args": null,
                              "kind": "FragmentSpread",
                              "name": "yourSayAuthorAuthor"
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "Article",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:1)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"section_top_515466\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "ba1427d5a9838cd72c1a4fa2ef4500f8";

export default node;
